const HomeIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='20'
		viewBox='0 0 20 20'
		width='20'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M2.5998 15.5996H4.9998V9.59961H10.9998V15.5996H13.3998V6.89961L7.9998 2.84961L2.5998 6.89961V15.5996ZM0.799805 17.3996V5.99961L7.9998 0.599609L15.1998 5.99961V17.3996H9.1998V11.3996H6.7998V17.3996H0.799805Z'
			fill='currentColor'
		/>
	</svg>
)

export { HomeIcon }
